import { useStore } from "../../app/stores/StoreContext";

export function useFormatCurrencyHook() {
  const { userStore } = useStore();

  return (amount: number, currency: string) => {
    const options: Intl.NumberFormatOptions = {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    } as Intl.NumberFormatOptions;

    return new Intl.NumberFormat(userStore.currentLanguage.code, options).format(amount);
  };
}
